import React from 'react';

import styles from './guide-animation.module.scss';

const Stations = ({ items, time, current }) => {
  return (
    <ul className={styles.stations}>
      {items &&
        items.map((item, index) => (
          <li
            key={item}
            className={`${styles.station}${
              current === index ? ` ${styles.stationCurrent}` : ''
            }`}
          >
            {item}
          </li>
        ))}
    </ul>
  );
};

export { Stations };
